module.exports = __webpack_public_path__ + "img/ave02.01f407cf.png";